export const environment = {
  enableTourLines: false,
  isEnabled:true,
  production: true,
  apiEndPoint: 'https://amgmaa-nonprod.mercedes-benz.com/aca',
  proxyEndpoint: 'https://proxy.int.stories.me/customerPortal',
    proxyAmapEndpoint: 'https://proxy.am.int.stories.me/customerPortal',
  supported_language: ['en-GB', 'en', 'de', 'de-DE', 'fr-FR', 'es-ES', 'cs-CZ', 'ko-KR', 'it-IT'],
  featureFlagLink:'../../assets/json/amap/feature-flag-amap-int.json',
  appRedirectUrl: 'https://int.stories4.me',
  domain: "https://int.stories.me/en-GB",
  localDealerShipUrl:'https://www.mercedes-amg.com/en/dealer',
  exploreGclassEventsUrl: 'https://g-class-experience.com/en/',
  exploreAmgEventsUrl: 'https://experience.mercedes-amg.com/en/',
  cmmCdnBaseUrl: 'https://int.assets.oneweb.mercedes-benz.com',
};
